import { useState } from 'react';
import isNil from 'lodash/isNil';
import type { OnMediaLoadingProps } from '../../../../../common/types/types';
export function useMediaLoadingErrorEvents() {
  const [isRefreshingSource, setIsRefreshingSource] = useState(false);
  const [isMediaElementLoading, setIsMediaElementLoading] = useState(false);
  const [mediaLoadingError, setMediaLoadingError] = useState<Error | undefined>(undefined);
  const handleLoading = (props: OnMediaLoadingProps) => {
    if ('isRefreshingSource' in props && !isNil(props.isRefreshingSource)) {
      setIsRefreshingSource(props.isRefreshingSource);
    }
    if ('isMediaElementLoading' in props && !isNil(props.isMediaElementLoading)) {
      setIsMediaElementLoading(props.isMediaElementLoading);
    }
  };
  const handleError = (error: Error) => {
    setMediaLoadingError(error);
  };
  return {
    isRefreshingSource,
    isMediaElementLoading: isMediaElementLoading,
    isAnyLoading: isRefreshingSource || isMediaElementLoading,
    mediaLoadingError,
    handleLoading,
    handleError
  };
}